module.exports = __webpack_public_path__ + "static/media/payNow.678d974e.png";